module.exports = __webpack_public_path__ + "icon_poyo-ecc96b2b150957657996bb39db7d0b67.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icon_poyo.png
// module id = 266
// module chunks = 86